import { Accordion } from "@au-schein-de/au-ui-library";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export function WhyTopPharmacyCollapsible({
	leftContent,
}: {
	leftContent?: ReactNode;
}) {
	const { t } = useTranslation("product");
	return (
		<Accordion.Root
			type="single"
			collapsible
			className="w-full"
			data-testid="why-top-pharmacy-collapsible"
		>
			<Accordion.Item value="why-top" className="border-0 bg-transparent p-0">
				<Accordion.Trigger
					variant="default"
					className="flex w-full items-center gap-2 p-0 hover:no-underline"
				>
					<div className="min-w-0 flex-1">{leftContent}</div>
					<span className="shrink-0 whitespace-nowrap text-body-sm text-gray-500">
						{t("vendor.picker.whyTopPharmacy")}
					</span>
				</Accordion.Trigger>
				<Accordion.Content className="pt-2 text-body-sm text-gray-500">
					{t("vendor.picker.whyTopPharmacyDescription")}
				</Accordion.Content>
			</Accordion.Item>
		</Accordion.Root>
	);
}
